/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { setVideoPlayerStateAction } from './videoplayerstate.actions';
import { SET_VIDEO_PLAYER_STATE } from './videoplayerstate.types';
import { VideoPlayerStates } from '../../../core/videoplayer/enums';
import { Log } from '../../../core/logging/Log';

const initialState: {
    playerState: VideoPlayerStates;
} = {
    playerState: VideoPlayerStates.NONE,
};

const TAG = 'videoplayerstate';

const videoPlayerStateReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_VIDEO_PLAYER_STATE:
            return {
                ...state,
                playerState: payload.playerState,
            };

        default:
            return state;
    }
};

export const setVideoPlayerState = (playerState: VideoPlayerStates) => (dispatch: Function) => {
    Diagnostics.info(TAG, 'setVideoPlayerState: ', playerState);
    Log.i(TAG, 'setVideoPlayerState: ', playerState);
    dispatch(setVideoPlayerStateAction(playerState));
};

export default videoPlayerStateReducer;
